import { render, staticRenderFns } from "./SamplePictureDetailsForm.vue?vue&type=template&id=dfde64ac&scoped=true&"
import script from "./SamplePictureDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./SamplePictureDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SamplePictureDetailsForm.vue?vue&type=style&index=0&id=dfde64ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfde64ac",
  null
  
)

export default component.exports